<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <div class="tw-mb-2">
    <legend>
      {{ $t('Select your business entity type') }}
    </legend>

    <WdsRadioGroup v-model:checked="internalModelValue" name="business_entity">
      <WdsRadio :disabled="disabled" value="limited">
        <i class="input-helper"></i>
        {{ $t('Limited Company (PSC)') }}
        <br />
        <span class="c-gray small">
          {{ $t('E.g. if you have a Personal Service Company setup.') }}
        </span>
      </WdsRadio>

      <WdsRadio :disabled="disabled" value="sole_trader">
        <i class="input-helper"></i>
        {{ $t('Registered Sole Trader') }}
        <br />
        <span class="c-gray small">
          {{ $t('If you have a Sole Trader business setup with HMRC.') }}
        </span>
      </WdsRadio>

      <WdsRadio :disabled="disabled" value="umbrella">
        <i class="input-helper"></i>
        {{ $t('Umbrella Company') }}
        <br />
        <span class="c-gray small">
          {{
            $t(
              'If you need to get paid as an employed contractor working under an Umbrella Company',
            )
          }}
        </span>
      </WdsRadio>

      <WdsRadio :disabled="disabled" value="no_setup">
        <i class="input-helper"></i>
        {{ $t('No setup yet') }}
        <br />
        <span class="c-gray small">
          {{ $t('If you are not working through a business') }}
        </span>
      </WdsRadio>
    </WdsRadioGroup>
  </div>
</template>

<script>
import { WdsRadio, WdsRadioGroup } from '@worksome/wds-components'
import { computed } from 'vue'

export default {
  components: {
    WdsRadio,
    WdsRadioGroup,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const internalModelValue = computed({
      get() {
        return props.modelValue
      },
      set(modelValue) {
        emit('update:modelValue', modelValue)
      },
    })
    return {
      internalModelValue,
    }
  },
}
</script>
